export default {
  getProducts(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      window.axios
        .get(`/marketplace?${queryString}`)
        .then(response => {
          context.commit("setProducts", response.data);
          resolve(response.data);
        })
        .catch(reject);
    });
  },
  getProduct(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/marketplace/${id}`)
        .then(response => {
          context.commit("setProduct", response.data);
          resolve(response.data);
        })
        .catch(reject);
    });
  },
  getCredit(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/marketplace/?type=credit&limit=1")
        .then(response => {
          context.commit("setCredit", response.data[0]);
          resolve(response);
        })
        .catch(reject);
    });
  }
};
